/* import __COLOCATED_TEMPLATE__ from './stripe-ach-setup-element.hbs'; */
import { action } from '@ember/object';
import {
  buildStripePaymentElement,
  buildStripeSetupModeElement,
} from 'client-portal/utils/stripe-payment-methods';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import styles from './stripe-ach-setup-element.module.scss';

export default class SiteBillingStripeAchSetupElement extends Component {
  styles = styles;

  @service stripe;
  @service localeManager;
  @service currentPractice;
  @service session;

  @tracked isSetupElementLoaded = false;
  @tracked dataCollectionAccepted = false;
  @tracked chargeExecutionAccepted = false;

  get mandatesAccepted() {
    return this.dataCollectionAccepted && this.chargeExecutionAccepted;
  }

  @action
  attachSetupElement(_element) {
    this.elements = buildStripeSetupModeElement(this.stripe.stripe, {
      paymentMethodType: 'us_bank_account',
      locale: this.localeManager.currentLocaleForStripe,
      currency: this.currentPractice.get('currency'),
      onBehalfOf: this.currentPractice.get('stripeConnectedAccountId'),
      featureStripeLinkPassthroughMode: this.currentPractice.get(
        'featureStripeLinkPassthroughMode'
      ),
    });

    let setupElementOptions = {
      onReady: () => {
        this.isSetupElementLoaded = true;
      },
      featureStripeLinkPassthroughMode: this.currentPractice.get(
        'featureStripeLinkPassthroughMode'
      ),
    };

    let client = this.session.currentClientAccess?.client;
    if (client) {
      setupElementOptions.email = client.email;
      setupElementOptions.phone = client.phoneNumber;
    }

    this.setupElement = buildStripePaymentElement(this.elements, setupElementOptions);

    this.setupElement.mount('#ach-setup-element');
  }

  @action
  toggleDataCollectionMandate(event) {
    this.dataCollectionAccepted = event.target.checked;
  }

  @action
  toggleChargeExecutionMandate(event) {
    this.chargeExecutionAccepted = event.target.checked;
  }

  @action
  async persistStripeAchPaymentMethod() {
    if (!this.mandatesAccepted) {
      return;
    }

    let { error } = await this.elements.submit();
    if (error) {
      return;
    }

    this.args.addStripeAchPaymentMethod(this.elements);
  }
}
